import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { InputDropdown, MultiLevelDropdown } from 'bonfire-kindling';
import _isEqual from 'lodash/isEqual';

const OpportunityTypesInputDropdown = ({
  availableValues,
  currentValues,
  onChange,
  TextFieldProps,
  MultiLevelDropdownProps,
}) => {
  const { t } = useTranslation();

  const tree = useMemo(
    () => [
      {
        children: availableValues.map(type => ({ label: type, value: type })),
        label: t('opportunities.filters.opportunity_type_all'),
        value: '',
      },
    ],
    [availableValues, t]
  );

  const inputValueFormatted = useMemo(
    () =>
      currentValues.length === availableValues.length
        ? t('opportunities.filters.opportunity_type_all')
        : currentValues.join(', '),
    [t, currentValues, availableValues]
  );

  return (
    <InputDropdown
      label={t('opportunities.filters.opportunity_type')}
      value={inputValueFormatted}
      TextFieldProps={{
        placeholder: t('opportunities.filters.opportunity_type_all'),
        InputProps: {
          inputProps: {
            sx: {
              cursor: 'pointer',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          },
        },
        ...TextFieldProps,
      }}
    >
      <MultiLevelDropdown
        initialChecked={availableValues}
        checked={currentValues}
        nodes={tree}
        onCheck={checked => {
          // `onCheck` is called everytime you open the dropdown for some reason which
          // causes a network request to be triggered since a new object is created in
          // state when calling `onChange`. This mitigates that by checking if the values
          // actually changed before calling `onChange`.
          if (!_isEqual(checked, currentValues)) {
            onChange(checked);
          }
        }}
        hideExpand
        disableReset
        disableSearch
        {...MultiLevelDropdownProps}
      />
    </InputDropdown>
  );
};

export default OpportunityTypesInputDropdown;
